import styled, { css } from "styled-components/macro";
import { ReactComponent as ClassicCornerSvg } from "./corner.svg";

export interface TabProps {
  activated?: boolean;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export const ClassicCorner = styled(ClassicCornerSvg)``;

export const ClassicTab = styled.div<TabProps>`
  padding: 12px 20px;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  border-radius: 20px 20px 0 0;
  background-color: ${(props) =>
    props.activated ? "#ffffff" : "rgba(255, 255, 255, 0.5)"};
  cursor: pointer;
  text-transform: uppercase;
  position: relative;
  letter-spacing: 0.02em;
  ${(props) =>
    props.disabled &&
    css`
      color: rgba(9, 21, 38, 0.35);
    `}
  ${ClassicCorner} {
    position: absolute;
    bottom: 0%;
    path {
      fill: ${(props) =>
        props.activated ? "#FFFFFF" : "rgba(255, 255, 255, 0.5)"};
      transition: fill 0.2s ease-in-out;
    }
    &:nth-child(1) {
      right: 100%;
    }
    &:nth-child(2) {
      left: 100%;
      transform: scale(-1, 1);
    }
  }
`;

export const PillsTab = styled.div<TabProps>`
  position: relative;
  background-color: #ffffff;
  border: 2px solid rgba(9, 21, 38, 0.15);
  box-sizing: border-box;
  border-radius: 30px;
  cursor: pointer;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  color: rgba(9, 21, 38, 0.6);
  padding: 12px 14px;
  min-width: 173px;
  text-align: center;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  text-transform: uppercase;
  &:hover {
    color: rgba(9, 21, 38, 0.85);
  }

  ${(props) =>
    props.activated &&
    css`
      background-color: #bdebff;
      border-color: transparent;
      color: rgba(9, 21, 38, 0.85);
      &:after {
        content: "";
        position: absolute;
        background: #bdebff;
        top: 100%;
        left: 50%;
        width: 14px;
        height: 14px;
        transform-origin: center;
        transform: translate(-50%, -5px) rotate(45deg);
        display: block;
        border-radius: 0px 0px 3px 0px;
      }
    `};
`;

export const ContrastPillsTab = styled.div<TabProps>`
  background-color: #ffffff;
  border-radius: 60px;
  cursor: pointer;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  color: rgba(9, 21, 38, 0.6);
  padding: 8px 16px;
  min-width: 60s;
  text-align: center;
  font-weight: bold;
  text-transform: uppercase;
  &:hover {
    color: rgba(9, 21, 38, 0.85);
  }

  ${(props) =>
    props.activated &&
    css`
      background-color: rgba(9, 21, 38, 0.85);
      color: #ffffff;
      &:hover {
        color: #ffffff;
      }
    `};
`;

export const Wrapper = styled.div`
  display: flex;
  ${ClassicTab} {
    margin-right: 3px;
  }
  ${PillsTab} {
    margin-right: 33px;
  }
`;
